import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IEscrowBalancesResponse } from '../../../types/order/escrow/response/IEscrowBalancesResponse';
import { IEscrowBalancesData } from '../../../types/order/escrow/data/IEscrowBalancesData';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export const convertResponseToData = (response: IEscrowBalancesResponse): IEscrowBalancesData => ({
  actualAmountDollars: response.actual_amount,
  actualAmountDollarsMismatchedFiltered: response.actual_amount_mismatched_filtered,
  availableAmountDollars: response.available_amount,
  availableAmountDollarsMismatchedFiltered: response.available_amount_mismatched_filtered,
  depositsTotalAmountDollars: response.deposits_total_amount,
  depositsTotalAmountDollarsMismatchedFiltered: response.deposits_total_amount_mismatched_filtered,
  disbursementsTotalAmountDollars: response.disbursements_total_amount,
  expectedBuyerCashToCloseAmountDollars: response.expected_buyer_cash_to_close_amount,
  expectedBorrowerCashToCloseAmountDollars: response.expected_borrower_cash_to_close_amount,
  expectedIncomingLenderAmountDollars: response.expected_incoming_lender_amount,
  expectedSellerCashToCloseAmountDollars: response.expected_seller_cash_to_close_amount,
});

export interface IGetEscrowBalancesForOrderIdProps {
  orderId: string;
}
export const getEscrowBalancesForOrderId = ({ orderId }: IGetEscrowBalancesForOrderIdProps) => {
  return APIFactory(baseUrlService.ApiLocation)
    .get<IEscrowBalancesResponse>(`escrow/v1/balances/${orderId}`)
    .then((t) => convertResponseToData(t.data))
    .catch(axiosErrorHandler);
};
